/*
 * File: d:\projects\AutoFiFront\src\Content\ScrollToTop\ScrollToTop.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday April 21st 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday April 21st 2023 4:40:56 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    // Extracts pathname property(key) from an object
    const { pathname } = useLocation();

    // Automatically scrolls to top whenever pathname changes
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return <></>
  }

export default ScrollToTop;
